import OAuth from '../../utils/OAuth2';
import moment from 'moment';
import { createReducer } from 'redux-act'
import * as a from '../actions/login'

const { url, redirectUri } = OAuth;

var DEFAULT_STATE = {
  auth: JSON.parse(window.localStorage.getItem('auth')),
  expireDate: window.localStorage.getItem('expireDate'),
  employeeInfo: JSON.parse(window.localStorage.getItem('employeeInfo')) || {
    costType: [],
    permission: {
      addCost: false,
      accountingPage: false,
      reportsPage: false,
      onMasrafFormuSumiagro: false
    },
    language:'tr'
  }
}

export default createReducer(
  {
    [a.setSession]: (state, payload) => {
      const sso = payload.sso;
      window.localStorage.setItem('auth', JSON.stringify(sso));
      if (sso !== null) {
        const expireDate = moment(moment.now()).add(parseInt(sso.expires_in), 'seconds').unix() * 1000;
        window.localStorage.setItem('expireDate', expireDate);
      }
      window.localStorage.setItem("employeeInfo", JSON.stringify({...payload, isCostPhotoRequired:true}));
      return {
        ...state,
        employeeInfo: payload,
        auth: payload.sso
      }
    },
    [a.setLanguage]: (state, language) => {
      let employeeInfo = JSON.parse(localStorage.getItem("employeeInfo"))
      employeeInfo.language= language
      window.localStorage.setItem("employeeInfo", JSON.stringify(employeeInfo));
      return {
        ...state,
        employeeInfo: {...state.employeeInfo, language }
      }
    },
    [a.removeSession]: (state, payload) => {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

      }
      window.localStorage.clear()
      window.location = `${url}/logout?redirect_uri=${redirectUri}`
      return { ...state }
    }
  },
  DEFAULT_STATE
);
